module.exports = __webpack_public_path__ + "static/img/subject_bg4.7b83265a.png";